import { Colors } from '@sigma-frontend-libs/commons'

import { components, sizes } from '@/utils'

import info from '@/components/info'
import tag from '@/components/tag'

function renderItem(h, item) {
  return h(
    components.card,
    {
      class: 'grid grid-gap--8 pa-2',
      props: {
        outline: true,
        rounded: true
      }
    },
    [
      h(
        tag,
        {
          props: {
            label: item.createdAt,
            color: Colors.grey,
            size: sizes.small
          }
        }
      ),
      h(
        info,
        {
          props: {
            value: item.message,
            color: Colors.error
          }
        }
      )
    ]
  )
}
function renderItems(h) {
  return this.items.map(item => {
    return renderItem.call(this, h, item)
  })
}
function renderContent(h) {
  if (this.items.length) {
    return renderItems.call(this, h)
  } else {
    return h(components.empty)
  }
}

export default function(h) {
  return h(
    'div',
    {
      class: 'grid grid-gap--8'
    },
    [ renderContent.call(this, h) ]
  )
}
